module.exports = __webpack_public_path__ + "static/media/3_9.b11e244f.png";